import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.CoreDialog, {
        attrs: {
          "data-qa": "dialog_town_select",
          size: _setup.dialogSize,
          "min-height": _setup.dialogMinHeight,
          title: _setup.dialogTitle,
          "slot-content-class": "header-town__dialog-content",
        },
        scopedSlots: _vm._u([
          {
            key: "prependBtn",
            fn: function () {
              return [
                _c(
                  VIcon,
                  {
                    staticClass: "cursor-pointer",
                    attrs: { "data-qa": "dialog_town_select_close" },
                    on: {
                      click: function ($event) {
                        _setup.isDialogActiveInternal = false
                      },
                    },
                  },
                  [_vm._v("\n        ui-icon-close-not-a-circle\n      ")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column flex-fill h-100 header-town__content",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-shrink-0 flex-grow-0 align-self-start w-100 mb-2 header-town__search",
                      },
                      [
                        _c(_setup.CoreSearchField, {
                          attrs: {
                            value: _setup.searchQuery,
                            maxlength: "150",
                            autocomplete: "off",
                            placeholder: _setup.translate(
                              "Начните вводить название, а мы подскажем"
                            ),
                            "data-qa": "dialog_town_select_search",
                            "debounce-ms": 500,
                          },
                          on: {
                            input: function ($event) {
                              _setup.searchQuery = $event
                            },
                            "input:debounced": _setup.loadAutocompleteResults,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _setup.isSearching
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex-grow-1 overflow-y-auto py-3 mt-2 header-town__scroll",
                          },
                          [
                            _c(_setup.HeaderTownList, {
                              attrs: {
                                items: _setup.searchItems,
                                "columns-class": _setup.townColumnsClass,
                                "data-qa": "dialog_town_autocomplete_list",
                              },
                              on: { select: _setup.handleTownSelect },
                            }),
                            _vm._v(" "),
                            !_setup.searchResults.length &&
                            !_setup.isAutocompleteLoading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-body-1 text-secondary--text pa-3 text-no-wrap header-town__autocomplete-empty",
                                    attrs: {
                                      "data-qa":
                                        "dialog_town_autocomplete_empty",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _setup.translate(
                                            "Совпадений не найдено"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "flex-grow-1 overflow-y-auto header-town__scroll",
                          },
                          [
                            _c(_setup.HeaderTownList, {
                              attrs: {
                                items: _setup.mainTownItems,
                                "columns-class": _setup.townColumnsClass,
                                "wrapper-class": "py-3 mt-2",
                                "data-qa": "dialog_main_town_select_list",
                              },
                              on: { select: _setup.handleTownSelect },
                            }),
                            _vm._v(" "),
                            _c(_setup.HeaderTownList, {
                              attrs: {
                                items: _setup.townItems,
                                "columns-class": _setup.townColumnsClass,
                                "wrapper-class": "py-3",
                                "data-qa": "dialog_town_select_list",
                              },
                              on: { select: _setup.handleTownSelect },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-4" },
                              [
                                _c("div", { staticClass: "text-h6 pa-3" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _setup.translate("Другие страны")
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(_setup.HeaderTownList, {
                                  attrs: {
                                    items: _setup.countryItems,
                                    "columns-class": _setup.townColumnsClass,
                                    "wrapper-class": "py-3 mt-2",
                                    "data-qa": "dialog_country_select_list",
                                  },
                                  on: { select: _setup.handleCountrySelect },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _setup.isDialogActiveInternal,
          callback: function ($$v) {
            _setup.isDialogActiveInternal = $$v
          },
          expression: "isDialogActiveInternal",
        },
      }),
      _vm._v(" "),
      !_vm.hideTrigger
        ? _c(
            "div",
            {
              staticClass: "cursor-pointer d-flex align-center",
              attrs: { "data-qa": "header_town_trigger" },
              on: { click: _setup.openDialog },
            },
            [
              _c("div", {
                staticClass: "ui-icon-map-pin text-secondary--text mr-3",
              }),
              _vm._v(" "),
              _c("div", { staticClass: "primary--text text-body-2" }, [
                _vm._v("\n      " + _vm._s(_setup.currentTownName) + "\n    "),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }